module.exports = {
        apiKey: "AIzaSyCawKTFw8DLmUoVawjTBQODxVE5K6wbrLE",
        authDomain: "comic-fb9b6.firebaseapp.com",
        databaseURL: "https://comic-fb9b6.firebaseio.com",
        projectId: "comic-fb9b6",
        storageBucket: "comic-fb9b6.appspot.com",
        messagingSenderId: "483165872574",
        appId: "1:483165872574:web:193976b7969ca9a0"
}